module.exports = __webpack_public_path__ + "assets/task-question-hover.svg";